import {NgModule, NO_ERRORS_SCHEMA} from "@angular/core";
import {HomePage} from "~/app/pages/home/home.page"
import {AboutPage} from "~/app/pages/about/about.page";
import {ComponentsModule} from "~/app/components/components.module";
import {CommonModule} from "@angular/common";
import {IonicModule} from "@ionic/angular";
import {PrivacyPolicyPage} from "~/app/pages/privacy-policy/privacy-policy.page";
import {TermsOfUsePage} from "~/app/pages/terms-of-use/terms-of-use.page";
import {SettingsPage} from "~/app/pages/settings/settings.page";
import {FormsModule} from "@angular/forms";
import {ContactUsPage} from "~/app/pages/contact-us/contact-us.page";
import {LogoutPage} from "~/app/pages/logout/logout.page";
import {LoginPage} from "~/app/pages/login/login.page";
import {SignupPage} from "~/app/pages/signup/signup.page";
import {LocationPage} from "~/app/pages/location/location.page";
import {ForgotPasswordPage} from "~/app/pages/forgot-password/forgot-password.page";
import {ValidatePage} from "~/app/pages/validate/validate.page";
import {ReferrerPage} from "~/app/pages/referrer/referrer.page";
import {SearchingPage} from "~/app/pages/searching/searching.page";
import {WelcomePage} from "~/app/pages/welcome/welcome.page";
import {OffersPage} from "~/app/pages/offers/offers.page";
import {OfferCouponOpenPage} from "~/app/pages/offer-coupon-open/offer-coupon-open.page";
import {MarkdownModule} from "ngx-markdown";
import {OfferPage} from "~/app/pages/offer/offer.page";
import {AllOffersPage} from "~/app/pages/all-offers/all-offers.page";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        FormsModule,
        ComponentsModule,
        MarkdownModule,
    ],
    declarations: [
        HomePage,
        AboutPage,
        ContactUsPage,
        LogoutPage,
        LoginPage,
        SignupPage,
        SearchingPage,
        SettingsPage,
        // SharePage,
        // ShareAppPage,
        // ShowCashierPage,
        // SponsorVideoPage,
        LocationPage,
        OffersPage,
        OfferCouponOpenPage,
        // NoOffersPage,
        // ThanksPage,
        WelcomePage,
        PrivacyPolicyPage,
        TermsOfUsePage,
        ValidatePage,
        ReferrerPage,
        ForgotPasswordPage,
        OfferPage,
      AllOffersPage,
        // SponsorPage
    ],
    exports: [
        HomePage,
        AboutPage,
        ContactUsPage,
        LogoutPage,
        LoginPage,
        SignupPage,
        SearchingPage,
        SettingsPage,
        // SharePage,
        // ShareAppPage,
        // ShowCashierPage,
        // SponsorVideoPage,
        LocationPage,
        OffersPage,
        OfferCouponOpenPage,
        // NoOffersPage,
        // ThanksPage,
        WelcomePage,
        PrivacyPolicyPage,
        TermsOfUsePage,
        ValidatePage,
        ReferrerPage,
        ForgotPasswordPage,
        OfferPage,
      AllOffersPage
    ],
    schemas: [
        NO_ERRORS_SCHEMA
    ]
})
export class PagesModule {
}
